import React, { useState } from "react";
import "./SearchComponent.scss";
import search from "../../assets/search.svg"
import close from "../../assets/close.svg"
import SearchItem from "./SearchItem/SearchItem";
import { useHistory } from "react-router";
import { useSelector } from "react-redux";
import { productsSearch } from "../../../../../utilities/apiRequests/productRegistryServerRequests";


const SearchComponent = ({ isOpen, setIsOpen }) => {
    const [query, setQuery] = useState("");
    const [filteredData, setFilteredData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const history = useHistory()
    const companyDetails = useSelector((state) => state.companyData.company)
    const orgID = companyDetails?.OrganisationID
    let settings = localStorage.getItem("ECOM_SETTINGS") && JSON.parse(localStorage.getItem("ECOM_SETTINGS")) || [];
    const salesLocID = settings.find((setting) => setting.OrgID === orgID) ? settings.find((setting) => setting.OrgID === orgID).SalesLocationID : ""

    const handleSearch = async (event) => {
        const searchValue = event.target.value.toLowerCase();
        setQuery(searchValue);
        let req = {
            "OrgID": companyDetails?.OrganisationID,
            "ProductName": searchValue,
            "Skip": 0,
            "Limit": 12,
            "LocationID": salesLocID
        }
        setIsLoading(true)
        await productsSearch(req).then((response) => {
            setFilteredData(response);
            setIsLoading(false)
        })
    };

    const toggleDrawer = () => {
        setIsOpen(!isOpen);
        setQuery("")
    };

    return (
        <>
            <div
                className={`overlay ${isOpen ? "visible" : ""}`}
                onClick={toggleDrawer}
            ></div>
            <div className={`SearchComponent ${isOpen ? "open" : ""}`}>
                <div className="search-input-container">
                    <div className="middle-container">
                        <div className="search-input">
                            <input
                                type="text"
                                value={query}
                                onChange={handleSearch}
                                placeholder="Search our store"

                            />
                            <div className="search-icon" >
                                <img alt="" src={search} />

                            </div>
                        </div>
                        <div className="close-container" onClick={toggleDrawer}>
                            <img alt="" src={close} />

                        </div>
                    </div>

                    {query !== "" && <div className="search-results">
                        <div className="search-header">PRODUCTS</div>
                        <div className="search-results-container">

                            {isLoading ? <div className="ecom-loader" /> : query !== "" && filteredData.length > 0 ? (
                                filteredData.map((item, key) => (
                                    <SearchItem item={item} key={key} onClick={() => {
                                        toggleDrawer()
                                        history.push(`/product/${item.ID}`)
                                    }} />
                                ))
                            ) : (
                                <div className="empty-result">No results found</div>
                            )}
                        </div>
                    </div>}
                </div>

            </div>
        </>
    );
};

export default SearchComponent;
